import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter, constant } from "@/router";
import role from "../../router/index";
import store from "@/store";

const state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  buttons: [],
  buttonName: [],
  menuList: [],
  parentList: [],
  taxId: "",
  userId: "",
  isHidden: false
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_BUTTONS: (state, buttons) => {
    state.buttons = buttons;
  },
  SET_BUTTO_NAME: (state, buttonName) => {
    state.buttonName = buttonName;
  },
  SET_MENU_LIST: (state, menuList) => {
    state.menuList = menuList;
  },
  SET_PARENT_LIST: (state, parentList) => {
    state.parentList = parentList;
  },
  SET_TAX_ID: (state, taxId) => {
    state.taxId = taxId;
  },
  SET_USER_ID: (state, userId) => {
    state.userId = userId;
  }
};

const actions = {
  // user login
  login({ commit }, param) {
    return new Promise((resolve, reject) => {
      login(param)
        .then(response => {
          const { data } = response;
          localStorage.setItem("names", data.username);
          localStorage.setItem("tels", data.loginPhone);
          localStorage.setItem("productType", data.productType);
          localStorage.setItem("taxType", data.taxType);

          // backdoor for hidden menu
          localStorage.setItem("lowTaxId", data.taxId);
          localStorage.setItem("isZzTax", data.isZzTax);
          localStorage.setItem("serviceMerchantId", data.serviceMerchantId);
          store.dispatch("domain/setSystemTitle", data.isZzTax);
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          localStorage.setItem("roleIsLogin", 1);
          this.state.user.id = data.id;
          localStorage.setItem("id", data.id);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(res => {
          const roles = role.options.routes;

          for (let i = 0; i < roles.length; i++) {
            roles[i].meta.allow = constant[i].meta.allow;
            roles[i].hidden = constant[i].hidden;
            if (roles[i].children) {
              for (let m = 0; m < roles[i].children.length; m++) {
                roles[i].children[m].meta.allow = constant[i].children[m].meta.allow;
                roles[i].children[m].hidden = constant[i].children[m].hidden;
              }
            }
          }

          const list = res.data.menuList;
          // button权限
          const buttonNameList = res.data.buttonNameList;

          const parentList = res.data.catalogList || [];
          let redirect = false;
          for (let i = 0; i < roles.length; i++) {
            for (let n = 0; n < list.length; n++) {
              if (roles[i].path === list[n].fpath) {
                roles[i].meta.allow = true;
                const parent = parentList.filter(item => {
                  return item.path === list[n].fpath;
                });
                if (roles[i].meta.title && parent.length) {
                  roles[i].meta.title = parent[0].label;
                }
                if (!roles[i].children) continue;
                for (let m = 0; m < roles[i].children.length; m++) {
                  const lowPath = roles[i].children[m].path.split("/")[0];
                  if (lowPath === list[n].path) {
                    roles[i].children[m].meta.allow = true;
                    if (list[n].label) roles[i].children[m].meta.title = list[n].label || roles[i].children[m].meta.title;
                    if (localStorage.getItem("roleIsLogin") === "1" && roles[i].children[m].path.split("/").length === 1) {
                      redirect = { path: (roles[i].path === "/" ? "" : roles[i].path) + "/" + roles[i].children[m].path };
                      localStorage.setItem("roleIsLogin", 0);
                    }
                  }
                }
              }
            }
          }
          for (let i = 0; i < roles.length; i++) {
            if (roles[i].children) {
              let num = 0;
              for (let m = 0; m < roles[i].children.length; m++) {
                if (!roles[i].children[m].meta.allow) {
                  roles[i].children[m].hidden = true;
                  num++;
                }
              }
              if (num === roles[i].children.length) {
                roles[i].hidden = true;
              }
            }
          }
          const buttonAuthList = res.data.buttonList;

          commit("SET_USER_ID", res.data.userId);
          commit("SET_TAX_ID", res.data.id);
          commit("SET_MENU_LIST", list);
          commit("SET_ROLES", roles);
          commit("SET_BUTTONS", buttonAuthList);
          commit("SET_BUTTO_NAME", buttonNameList);
          commit("SET_PARENT_LIST", parentList);
          resolve({ roles: JSON.stringify(roles), redirect: redirect });
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_BUTTONS", []);
          commit("SET_PARENT_LIST", []);
          removeToken();
          // resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch("tagsView/delAllViews", null, { root: true });

          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      commit("SET_BUTTONS", []);
      commit("SET_PARENT_LIST", []);
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + "-token";

    commit("SET_TOKEN", token);
    setToken(token);

    const { roles } = await dispatch("getInfo");

    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch("permission/generateRoutes", roles, { root: true });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch("tagsView/delAllViews", null, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
